import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EscalationModel } from '../../components/escalation/escalation.model';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { getUuidV4 } from '../../utilities/generic-utilities';
import { OdataService } from '../odata/odata.service';

@Injectable({
    providedIn: 'root',
})
export class OdataEscalationService {
    public constructor(private readonly odataService: OdataService) {}

    public saveEscalationStatus(escalation: EscalationModel): Observable<unknown> {
        return this.odataService.deepInsertRequest(
            escalation,
            ENDPOINTS.EscalationSet,
            `${escalation.notificationId.toString()}-${getUuidV4()}`,
        );
    }
}
